const COLORS = {
  darkOrange: "#A46843",
  teal: "#1CB5AB", // 00b5ad
  lightGold: "#DDB677",
  solitude: "#E9EDF1",
  darkGrey: "#212121",
  lightGrey: "#767676",
  lightBlue: "#F2F3F6",
  disabledGrey: "#C2C1C1",
  contentGrey: "#F2F3F5",
  white: "#FFFFFF",
  transparent: "#00000000",
  borderLightGrey: "rgba(34, 36, 38, 0.1)",
  borderDarkGrey: "#d4d4d5",
  greyOnBlack: "#B3B8BD",
  red: "#db2828",
  blue: "#2185D0",
  darkBlue: "#1B5BA4",
  yellow: "#FBBD08",
  black87: "rgba(0, 0, 0, 0.87)"
};
export default COLORS;
